import React from 'react';

export class CaloriesWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      averageHeartRate: 0,
      lastMillis: new Date().getTime(),
      startTime: new Date().getTime() + 1,
    };
  }

  calories = () => {
    if (this.props.configuration) {
      return (
        ((-20.4022 +
          0.4472 * this.state.averageHeartRate -
          0.1263 * this.props.configuration.weight +
          0.074 * this.props.configuration.age) /
          4.184) *
        ((this.state.lastMillis - this.state.startTime) / 60000)
      );
    } else {
      return 0;
    }
  };

  componentWillReceiveProps(nextProps, nextContext) {
    let {averageHeartRate, lastMillis, startTime} = this.state;
    let pulse = nextProps.pulse;
    let currentTime = new Date().getTime();

    let timeElapsedBefore = lastMillis - startTime;
    let timeElapsedNow = currentTime - lastMillis;

    let newAverageHeartRate =
      (timeElapsedBefore * averageHeartRate + timeElapsedNow * pulse) /
      (timeElapsedNow + timeElapsedBefore);

    if (isNaN(newAverageHeartRate)) {
      newAverageHeartRate = averageHeartRate;
    }

    this.setState({
      averageHeartRate: newAverageHeartRate,
      lastMillis: currentTime,
    });
  }

  render() {
    return (
      <>
        {this.props.configuration && (
          <div
            style={{
              backgroundColor: this.props.fromLaunch
                ? this.props.configuration.backgroundColor
                : 'transparent',
              // position: "absolute",
              // top: 0,
              // right: 0,
              // bottom: 0,
              // left: 0,
              fontSize: '5em',
              textAlign: 'center',
              fontFamily: this.props.configuration.font,
              color: this.props.configuration.fontColor,
            }}
          >
            <link
              href={`https://fonts.googleapis.com/css?family=${this.props.configuration.font}`}
              rel={'stylesheet'}
            />
            {this.calories() < 0 ? 0 : Math.abs(Math.floor(this.calories()))}
          </div>
        )}
      </>
    );
  }
}
